import { EventContentArg } from "@fullcalendar/core";

/** DOM text nodes keep customer-supplied names safe without HTML interpolation. */
export function renderCalendarEvent(arg: EventContentArg) {
  const props = arg.event.extendedProps;
  const root = document.createElement("div");
  root.className = "schedule-event";
  const lines = [
    arg.timeText,
    arg.event.title,
    props["kind"] === "court-unavailability"
      ? `Blocked: ${props["block"]?.reasonCode?.replace("_", " ") ?? "Unavailable"}`
      : `${props["playerCount"] ?? 0} players · ${props["status"] ?? "Booking"}`,
  ];
  for (const [index, text] of lines.entries()) {
    const line = document.createElement(index === 1 ? "strong" : "span");
    line.textContent = text;
    root.appendChild(line);
  }
  return { domNodes: [root] };
}

export function presentBooking(booking: any, courts: any[]) {
  const court = courts.find((c) => String(c._id) === String(booking.courtId));
  const title = court?.name ?? "Booking";
  const accent = /football/i.test(title)
    ? "#047857"
    : /basketball/i.test(title)
      ? "#c2410c"
      : "#7c3aed";
  return {
    ...booking,
    title,
    backgroundColor: "#f8fafc",
    borderColor: accent,
    textColor: "#172554",
    display: "block",
    classNames: ["booking-event"],
    extendedProps: {
      ...booking.extendedProps,
      courtId: booking.courtId,
      status: booking.status,
      playerCount: booking.playerCount,
      reference: booking.title,
    },
  };
}
